'use strict';
(function (angular) {
	const template = `
		<span class="pmt-icon pmt-icon--svg">
			<svg><use xlink:href="" ng-attr-xlink:href="{{'#pmt-icon__' + $ctrl.svg}}"></use></svg>
		</span>
	`;

	angular.module('PinMeTo.UI').component('pmtIcon', {
		template: template,
		bindings: {
			svg: '@'
		}
	});
})(window.angular);
